import api from './api';

export const databaseService = {
  getCollectionsStatus: () => api.get('/database/collections-status'),
  clearData: () => api.post('/database/clear-data'),
  deleteEmailTemplates: () => api.delete('/database/email-templates'),
  deleteWorkItems: () => api.delete('/database/work-items'),
  deleteProjectStatuses: () => api.delete('/database/project-statuses'),
  deleteVendors: () => api.delete('/database/vendors'),
  backfillProposalTool: (dryRun = true) => api.post(`/database/backfill-proposal-tool?dry_run=${dryRun}`),
};
